let component = require("./keyboard.vue");

module.exports = {
    component,
    // eslint-disable-next-line global-require
    layouts: require("./layouts"),

    install(Vue) {
        Vue.component("VueTouchKeyboard", component);
    }
};
